import { BasketItemSource } from '@epicuro-next/models/basket';
import { go } from '@epicuro-next/state/router-store';
import { Action, createAction, props } from '@ngrx/store';

import { ConfigStripActivationSource, ProductSourceDetails } from '../models';

export const activateConfigStrip = createAction(
  '[Config Strip] Activate config strip',
  props<{
    product: {
      brandId: string;
      productId: string;
      parent?: {
        productId: string;
      } | null;
    };
    index: number;
    source: {
      source: ConfigStripActivationSource;
      subSource?: BasketItemSource;
      details?: ProductSourceDetails;
    };
    setSourceNeeded?: boolean;
  }>(),
);

export const confirmToPersistBeforeLeaving = createAction(
  '[Config Strip] Confirm To Persist Before Leaving',
  props<{
    navigationAction?: ReturnType<typeof go>;
    continuationActions: Action[];
  }>(),
);

export const leavingAborted = createAction('[Config Strip] Leaving Aborted');
